import React from 'react';
import PropTypes from 'prop-types';
import { CONTACTS } from '@department-of-veterans-affairs/component-library/contacts';

export function UnknownRep({ DynamicHeader }) {
  return (
    <va-alert
      data-testid="unknown-rep"
      close-btn-aria-label="Close notification"
      status="error"
      uswds
      visible
    >
      <DynamicHeader
        className="vads-u-font-size--h3 vads-u-margin-top--0"
        slot="headline"
      >
        We can’t check if you have an accredited representative.
      </DynamicHeader>
      <React.Fragment key=".1">
        <p>We’re sorry. There’s a problem with our system. Check back later.</p>

        <p className="vads-u-margin-y--0">
          If there’s still a problem, call us at{' '}
          <va-telephone contact={CONTACTS.VA_BENEFITS} /> to check if you have
          an accredited representative.
        </p>
      </React.Fragment>
    </va-alert>
  );
}

UnknownRep.propTypes = {
  DynamicHeader: PropTypes.string,
};
